import { MDRLandingPage } from "./MDRLandingPage";
import { EastLandingPage } from "./EastLandingPage";

export const LANDING_PAGES = {
  MDR: MDRLandingPage,
  "East Coast Christian Conference": EastLandingPage,
};
